import { FlexibleContentProps } from '@sola/schema/lib/schema.js';

import { FeatureBase } from '../../../molecules/feature-base/feature-base';
import { HeaderGroup } from '../../../molecules/header-group/header-group';
import { getBaseSizeProps } from '../../../utils/text-utils';

export const BasicContentSolo: React.FC<FlexibleContentProps> = ({
  seoLevel = 2,
  media: _media,
  quotation: _quotation,
  alt,
  inline,
  ...props
}) => {
  const hasHeaderGroup = !alt;

  return (
    <section className="BasicContentSolo component component--container">
      <div className="container container--inline-box">
        {hasHeaderGroup && (
          <HeaderGroup
            {...props}
            {...getBaseSizeProps(seoLevel, inline)}
            displayLevel={seoLevel}
            seoLevel={seoLevel}
          />
        )}
        {!hasHeaderGroup && (
          <div className="w-full max-w-md mx-auto">
            <FeatureBase
              {...props}
              {...getBaseSizeProps(seoLevel, inline)}
              seoLevel={seoLevel}
              variant={alt ? 'centered' : 'standard'}
              inline
            />
          </div>
        )}
      </div>
    </section>
  );
};
